import React from 'react';
import SanitizedHtml from 'src/components/ui/SafeHtml/SanitizedHtml';
import Icon from '../Icon/Icon';
import module from './TimelineStep.module.scss';

const getStateColor = (state: 'completed' | 'pending' | 'failed') => {
  if (state === 'completed') return 'status-success-full-bg';
  if (state === 'pending') return 'bg-color-grey-300';
  if (state === 'failed') return 'status-error-full-bg';
  return 'bg-color-grey-300'; // Default fallback
};

interface TimelineStepProps {
  title: string;
  datetime: string;
  state: 'completed' | 'pending' | 'failed';
  isLastStep?: boolean;
}

const TimelineStep: React.FC<TimelineStepProps> = ({ title, datetime, state, isLastStep = false }) => {
  return (
    <div className="flex gap-16">
      <div className="items-center">
        <div
          className={`${module.icon} h-6 w-6 rounded-full mt-2 flex items-center justify-center text-white ${getStateColor(state)}`}>
          {state === 'completed' && <Icon name="checkmark" />}
        </div>
        {!isLastStep && <div className={module.line} />}
      </div>
      <div className="pb-8">
        <SanitizedHtml as="p" className="typo-text-14 mb-6" html={title} />
        <time className="typo-text-12 text-faded">{datetime}</time>
      </div>
    </div>
  );
};

export default TimelineStep;
